<template>
  <div class="contract-discount">
    <b-form-group label-align-md="left" class="required-control">
      <label>Loại thanh toán:</label>
      <b-form-select
        class="select-style"
        v-model="contractData.paymentType"
        size="sm"
        :disabled="isDisabled"
      >
        <b-form-select-option value="INSTALLMENT">
          Trả góp
        </b-form-select-option>
        <b-form-select-option value="DIRECTLY">
          Trả thẳng
        </b-form-select-option>
      </b-form-select>
    </b-form-group>
    <b-form-group>
      <label>Chiết khấu</label>
      <b-input-group>
        <template #append>
          <b-button
            size="sm"
            style="width: 40px"
            variant="secondary"
            @click="onChangeDiscountType"
            :disabled="isDisabled"
          >
            <i
              v-if="selectDiscountType === DISCOUNT_AMOUNT_TYPE.PERCENT"
              class="fa fa-percent"
              aria-hidden="true"
            ></i>
            <i v-else class="fas fa-dollar-sign" aria-hidden="true"></i>
          </b-button>
        </template>
        <template class="relative">
          <b-form-input
            size="sm"
            class="text-right"
            id="input-discount"
            v-model="contractData.totalDiscountAmount"
            :min="1"
            v-mask="mask"
            :disabled="isDisabled"
            autocomplete="off"
          ></b-form-input>
          <label class="absolute text-primary">{{
            selectDiscountType === DISCOUNT_AMOUNT_TYPE.PERCENT
              ? 'Phần trăm'
              : 'Tiền mặt'
          }}</label>
        </template>
      </b-input-group>
    </b-form-group>
    <b-row>
      <b-col md="6">
        <b> Tổng trước chiết khấu: </b>
      </b-col>
      <b-col md="6">
        <p class="text-right textFinal">
          {{
            convertPrice(
              totalAmountBeforeAfterDiscount.totalBeforeDiscount || 0,
            )
          }}
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b class="text-success"> Tổng sau chiết khấu: </b>
      </b-col>
      <b-col md="6">
        <p class="text-right textFinal">
          {{
            convertPrice(totalAmountBeforeAfterDiscount.totalAfterDiscount || 0)
          }}
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { DISCOUNT_AMOUNT_TYPE } from '@/utils/enum';
import { convertPrice, currencyMask, calTotalDiscount } from '@/utils/common';
import { unMaskPrice } from '../../../utils/common';

// import {

//     makeToastFaile,
//     makeToastSuccess,
//     unMaskPrice,
// } from '@/utils/common';
export default {
  props: ['contractData', 'isDisabled'],
  data() {
    return {
      DISCOUNT_AMOUNT_TYPE,
      selectDiscountType: 'AMOUNT',
      mask: currencyMask,
    };
  },
  computed: {
    totalAmountBeforeAfterDiscount() {
      return this.calTotalAmountBeforeAfterDiscount(
        this.contractData,
        this.contractData.contractDetail,
      );
    },
  },
  mounted() {
    if (this.contractData) {
      this.selectDiscountType = this.contractData.discountType;
    }
  },
  methods: {
    convertPrice,
    calTotalDiscount,
    calTotalAmountBeforeAfterDiscount(
      discountContract,
      discountContractDetail,
    ) {
      const { discountType, totalDiscountAmount } = discountContract;

      let totalBeforeDiscount = 0,
        totalAfterDiscount = 0;

      for (let i = 0; i < discountContractDetail.length; i++) {
        const item = discountContractDetail[i];
        totalBeforeDiscount = totalBeforeDiscount + Number(item['totalAmount']);
      }

      totalAfterDiscount = calTotalDiscount(totalBeforeDiscount, {
        discountType,
        discountAmount: unMaskPrice(totalDiscountAmount),
      });

      return { totalBeforeDiscount, totalAfterDiscount };
    },
    onChangeDiscountType() {
      // dảo ngược loại chiết khấu
      this.selectDiscountType =
        this.selectDiscountType === this.DISCOUNT_AMOUNT_TYPE.PERCENT
          ? this.DISCOUNT_AMOUNT_TYPE.MONEY
          : this.DISCOUNT_AMOUNT_TYPE.PERCENT;
      this.contractData.discountType = this.selectDiscountType;
    },
  },
};
</script>

<style></style>
